module.exports = __webpack_public_path__ + "fonts/iconfont.31a18f78.ttf";